module.exports = __webpack_public_path__ + "media/assets/avia/sidebar/clock-dd0ab79613ff080f2b5ad83b845d73ed.png";